export const OTHER_ID = 'Other';
const getIsValueFromOptions = (options, value)=>options?.find((option)=>(option.value ?? option.label) === value);
export const getIsOtherOptionSelected = (options, value)=>Boolean(value) && !getIsValueFromOptions(options, value);
export const getOtherLabel = (addOtherLabel, t)=>{
    const otherLabelDefault = t?.('add-other.default-other-option-label');
    return addOtherLabel || otherLabelDefault || OTHER_ID;
};
export const getOtherValue = (value, addOtherLabel)=>{
    const addedSymbolsLength = 2; // we add ': ' to other value
    const otherLabelLength = addOtherLabel ? addOtherLabel.length + addedSymbolsLength : 0;
    return value.slice(otherLabelLength);
};

//# sourceMappingURL=radio-group-field-utils.js.map